module.exports = __webpack_public_path__ + "img/logo-dark_cut.50422bde.png";